import styled from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border-radius: 50%;\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  line-height: 1em;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var InlineRoundIcon = styled.span.attrs({
    role: "img"
})(_templateObject(), function(param) {
    var color = param.color;
    return color;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});
var PrimaryInlineRoundIcon = styled(InlineRoundIcon).attrs(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.colors.primary,
        color: theme.colors.white
    };
})(_templateObject1());

export { InlineRoundIcon, PrimaryInlineRoundIcon };
